import {
	appointmentVars,
	clientVars,
	companyVars,
	extraShootVars,
	invoiceJobVars,
	invoiceReminderVars,
	jobVars,
	linkVars,
	paymentVars,
	secondaryClientVars
} from '@models/system-variables/variable-groups';
import { exclude } from '@models/system-variables/helpers';

export interface IVariable {
	key: string;
	name: string;
}

export type VariableListTypes =
	| 'CLIENT_MENU'
	| 'CLIENT_MENU_SUBJECT'
	| 'JOB_MENU'
	| 'JOB_MENU_SUBJECT'
	| 'PRODUCT_MENU'
	| 'PICK_AND_CHOOSE_MENU'
	| 'CONTRACT_MENU'
	| 'INVOICE_MENU'
	| 'INVOICE_MENU_SUBJECT'
	| 'APPOINTMENT_REMINDER_MENU'
	| 'APPOINTMENT_REMINDER_MENU_SUBJECT';

export const variablesList = {
	CLIENT_MENU: {
		...companyVars,
		...clientVars
	},
	CLIENT_MENU_SUBJECT: {
		...companyVars,
		...exclude(clientVars, ['Client Notes'])
	},
	JOB_MENU: {
		...companyVars,
		...clientVars,
		...secondaryClientVars,
		...jobVars,
		...invoiceJobVars,
		...appointmentVars,
		...extraShootVars,
		...linkVars
	},
	JOB_MENU_SUBJECT: {
		...companyVars,
		...exclude(clientVars, ['Client Notes']),
		...secondaryClientVars,
		...exclude(jobVars, ['Lead/Job Notes']),
		...invoiceJobVars,
		...appointmentVars,
		...extraShootVars
	},
	PRODUCT_MENU: {
		...companyVars,
		...clientVars,
		...secondaryClientVars,
		...jobVars,
		...paymentVars,
		...invoiceJobVars,
		...linkVars
	},
	PICK_AND_CHOOSE_MENU: {
		...companyVars,
		...clientVars,
		...secondaryClientVars,
		...jobVars,
		...linkVars
	},
	CONTRACT_MENU: {
		...companyVars,
		...clientVars,
		...secondaryClientVars,
		...jobVars,
		...invoiceJobVars,
		...linkVars
	},
	INVOICE_MENU: {
		...companyVars,
		...clientVars,
		...secondaryClientVars,
		...jobVars,
		...paymentVars,
		...invoiceJobVars,
		...appointmentVars,
		...extraShootVars,
		...linkVars
	},
	INVOICE_MENU_SUBJECT: {
		...companyVars,
		...exclude(clientVars, ['Client Notes']),
		...secondaryClientVars,
		...exclude(jobVars, ['Client Notes', 'Lead/Job Notes']),
		...paymentVars,
		...invoiceJobVars,
		...appointmentVars,
		...extraShootVars
	},
	APPOINTMENT_REMINDER_MENU: {
		...companyVars,
		...clientVars,
		...invoiceReminderVars
	},
	APPOINTMENT_REMINDER_MENU_SUBJECT: {
		...companyVars,
		...exclude(clientVars, ['Client Notes']),
		...invoiceReminderVars
	}
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/models/system-variables/variables-to-insert.ts